import React, { useState } from 'react';
import { styled } from '@mui/system';
import {
  Drawer as MuiDrawer,
  Toolbar,
  IconButton,
  Divider,
  Typography,
  Switch,
  Button,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Box
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ListPerson from './ListPerson';
import { useGlobalContext } from '../context/GlobalContext';
import { useHomeworkContext } from '../context/HomeworkContext';

const drawerWidth = 280;

const StyledDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const DrawerAdmin = ({ open, toggleDrawer,handleClickOpen}) => {
  const { setSelectedUser, setTotalStars } = useGlobalContext();
  const { group, setGroup } = useHomeworkContext();

  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('active');

  const switchGroup = (event) => {
    setSelectedUser(null);
    setGroup(event.target.checked ? 'students' : 'teachers');
    setSearchQuery('');
    setTotalStars(0);
  };

  const handleSearchQuery = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  return (
    <StyledDrawer variant="permanent" open={open}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: [1],
          height: '5vh'
        }}
      >
        <Typography>Teacher</Typography>
        <Switch
          checked={group === 'students'}
          onChange={switchGroup}
          inputProps={{ 'aria-label': 'toggle group' }}
        />
        <Typography>Student</Typography>
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      {open && (
        <Box
          sx={{
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center',
            height: '150px', // 고정 높이 설정
            overflow: 'visible',
            '@media (max-width: 600px)': {
              height: '120px', // 작은 화면에서 높이 조정
            },
          }}
        >
          <Button onClick={handleClickOpen}>
            {group === 'students' ? 'New Student' : 'New Teacher'}
          </Button>
          <FormControl component="fieldset">
            <TextField
              sx={{ m: 2 }}
              id="search-field"
              label="Search Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={handleSearchQuery}
            />
            <RadioGroup row value={statusFilter} onChange={handleStatusChange} sx={{ display: 'flex', mx: 2 }}>
              <FormControlLabel value="active" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.6rem' }}>Active</Typography>} />
              <FormControlLabel value="inactive" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.6rem' }}>Inactive</Typography>} />
              <FormControlLabel value="all" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.6rem' }}>All</Typography>} />
            </RadioGroup>
          </FormControl>
        </Box>
      )}
      <ListPerson
        searchQuery={searchQuery}
        statusFilter={statusFilter}
        open={open}
      />
    </StyledDrawer>
  );
};

export default DrawerAdmin;